/**
 * @ts-nocheck
 */

// @ts-ignore
export const API_ENDPOINT: string = import.meta.env.VITE_API_ENDPOINT;
// @ts-ignore
export const SENTRY_ENABLED: boolean =
  import.meta.env.VITE_SENTRY_ENABLED === "yes";
